module.exports = __webpack_public_path__ + "img/1.c2cbb18a.png";